import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { type VariantProps } from "class-variance-authority"
import BadgeVariants from "./badgeVariants"
import { cn } from "../../../utils"

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof BadgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span"

  return (
    <Comp
      data-slot="label"
      className={cn(BadgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge, BadgeVariants }
